<template>
  <div class="popUp-container">
    <Modal v-model="modal" width="560" @on-cancel='back' :styles="{ top: '30%' }" :footer-hide='true' @on-ok='ok' >
        <div class="text-container tc">
          {{msg}}
        </div>
        <div class="btn-container fbox fbox-ac fbox-ja">
          <div class="left-btn tc fsh" @click="cancel">
            取消
          </div>
          <div class="right-btn color-white tc" @click="ok">
            {{text}}
          </div>
        </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'popUp',
  props: {
    modal: {
      type: Boolean
    },
    text: {
      type: String
    },
    msg: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    back () {
      this.cancel()
    },
    ok () {
      this.$emit('ok')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang='scss' scoped>
.popUp-container{
  ::v-deep{
    .ivu-modal{
      top: 200px;
    }
  }
}
.text-container{
  width: 288px;
  color: #24272F;
  font-size: 24px;
  margin: 0 auto;
  padding: 90px 0 60px;
}
.btn-container{
  width: 100% !important;
  font-size: 20px;
  padding-bottom: 50px;
  .left-btn{
    width: 160px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #868A99;
    border-radius: 4px;
    color: #150F07;
    cursor: pointer;
  }
  .right-btn{
    width: 160px;
    height: 50px;
    line-height: 50px;
    background: #28B28B;
    border-radius: 4px;
    cursor: pointer;
  }
}
@media(max-width: 992px) {
  .text-container{
    font-size: 18px !important;
  }
  .btn-container{
    font-size: 16px !important;
    .left-btn{
      width: 100px !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .right-btn{
      width: 100px !important;
      height: 40px !important;
      line-height: 40px !important;
    }
  }
}
</style>
